import { render } from "./ModalConfiguracoesPlacar.vue?vue&type=template&id=3d25b798&scoped=true"
import script from "./ModalConfiguracoesPlacar.vue?vue&type=script&lang=js"
export * from "./ModalConfiguracoesPlacar.vue?vue&type=script&lang=js"

import "./ModalConfiguracoesPlacar.vue?vue&type=style&index=0&id=3d25b798&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d25b798"]])

export default __exports__